export default "__VITE_ASSET__8dPlpGok__"